import { useMemo } from "react"
import { useIsDesktop } from "../providers/DeviceProvider"
import useWindowSize from "./useWindowSize"

const generatePaths = (width = 0, bendPower = 0.15) => {
	const w = width || 0
	const center = w / 2
	const bp = Math.round(w * bendPower)
	return {
		width: w,
		open: {
			initialPath: `M0 0 L${w} 0 Q${center} ${-bp} 0 0`,
			targetPath: `M0 0 L${w} 0 Q${center} ${bp} 0 0`,
			finalPath: `M0 0 L${w} 0 Q${center} 0 0 0`,
		},
		close: {
			targetPath: `M0 0 L${w} 0 L${w} ${bp} Q${center} ${-bp / 2} 0 ${bp} Z`,
			initialPath: `M0 0 L${w} 0 L${w} 0 Q${center} 0 0 0 Z`,
		},
	}
}

export default function useMenuCurveSvgPaths() {
	const isDesktop = useIsDesktop()
	const { width } = useWindowSize()
	const bendPower = isDesktop ? 0.15 : 0.225
	return useMemo(() => generatePaths(width, bendPower), [width, bendPower])
}
